import React, { useEffect, useState } from "react";
import API from '../api';

function LiveAlertScroller() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    loadAlerts();
    const interval = setInterval(loadAlerts, 150000); // refresh every 15s
    return () => clearInterval(interval);
  }, []);

  const loadAlerts = async () => {
    try {
      const res = await API.get('api/live-alerts');
      setAlerts(res.data);
    } catch (err) {
      console.error("Alert fetch failed");
    }
  };

  return (
    <div className="live-alert-box">
      <h4 className="text-center mb-3">Top Live Stock Alerts</h4>

      <div className="alert-scroller">
        <ul>
          {alerts.map(a => (
            <li key={a.id}>
              <span>{a.message}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LiveAlertScroller;
